import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function TickIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 19 19">
      <path d="M6.5227 16.5079C6.1775 16.5079 5.83231 16.3301 5.65971 16.0634L1.77628 11.262C1.34478 10.7285 1.43108 10.0171 1.94887 9.57257C2.46666 9.12799 3.15705 9.21691 3.58855 9.7504L6.609 13.4848L15.4115 2.90393C15.8429 2.37044 16.5333 2.37044 17.0511 2.81502C17.5689 3.25959 17.6552 4.05983 17.2237 4.50441L7.38568 16.0634C7.12679 16.3301 6.86789 16.5079 6.5227 16.5079Z" fill="currentColor" />
    </SvgIcon>
  );
}
